var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseListIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.707 7.91449C13.3165 8.30501 12.6833 8.30501 12.2928 7.91449L6.99992 2.62159L1.70703 7.91449C1.31651 8.30501 0.683342 8.30501 0.292818 7.91449C-0.0977068 7.52396 -0.0977068 6.8908 0.292818 6.50027L6.29282 0.500275C6.68334 0.109751 7.31651 0.109751 7.70703 0.500275L13.707 6.50027C14.0976 6.8908 14.0976 7.52396 13.707 7.91449Z",
    fill: "#143641"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseListIcon);
export default __webpack_public_path__ + "static/media/closeListIcon.89b3fdd8cebae21e0b5549d6db956bc2.svg";
export { ForwardRef as ReactComponent };